<section id="servicios-grid" class="services-grid-section dingo-section dingo-bg-accent">
  <div class="container">
    <div class="services-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <p class="services-kicker">Ecosistema de soluciones</p>
      <h2 class="services-section-title">
        Elige el servicio correcto para tu <span class="highlight-green">siguiente etapa</span>
      </h2>
      <p class="services-section-desc">
        Desde adquisición y contenido hasta tecnología, datos y operación. Diseñamos el stack que tu negocio necesita.
      </p>
    </div>

    <div class="services-card-grid">
      @for (service of services; track service.title; let i = $index) {
      <a class="service-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i % 4" [routerLink]="service.route">
        <span class="service-card-tag">{{ service.tag }}</span>
        <div class="service-card-icon">
          <i class="{{ service.icon }}"></i>
        </div>
        <h3>{{ service.title }}</h3>
        <p>{{ service.description }}</p>
        <span class="service-card-link">
          Ver servicio
          <i class="bi bi-arrow-right"></i>
        </span>
      </a>
      }
    </div>
  </div>
</section>
